module.exports = __webpack_public_path__ + "img/awards@2x.4fd0142.webp";